import { ITEM_STATE_SAVED_ITEM_LOADED } from "../../../constants";
import setItemState from "../setItemState";

export default ({ state, id }) => {
  const newState = setItemState(state, id, ITEM_STATE_SAVED_ITEM_LOADED);

  return { ...newState };
};
